import React, { FC } from "react"

import { GroupDocument } from "../../../../contexts/devices-context"
import CameraModuleSettings from "./CameraModuleSettings"
import useModuleAttributes from "../../hooks/useModuleAttributes"

type GroupCameraModuleSettingsProps = {
    group: GroupDocument
}

const _GroupCameraModuleSettings: FC<GroupCameraModuleSettingsProps> = ({ group }) => {
    const attrs = useModuleAttributes<"duration">(group, "camera")

    return <CameraModuleSettings attrs={attrs} organisation={group.organisation} group={group.id} />
}

export default _GroupCameraModuleSettings
